import React from "react";
import {
  IonItem,
  IonItemGroup,
  IonLabel,
  IonSearchbar,
  IonToolbar,
  IonSkeletonText,
} from "@ionic/react";
import { format } from "date-fns";
import { id as indo } from "date-fns/locale";
import { useEffect, useState } from "react";
import { useCollection } from "react-firebase-hooks/firestore";
import { useFirebase } from "../firebase-provider";

const TransactionFinish: React.FC = () => {
  const [listTransaksi, setListTransaksi] = useState<any>([]);
  const [filter, setFilter] = useState<string>("");

  const { firestore } = useFirebase();
  const [snapshots, loading] = useCollection(
    firestore.collection("transaksi").where("status", "==", "Selesai")
  );

  useEffect(() => {
    if (snapshots) {
      setListTransaksi(snapshots.docs);
    }
  }, [snapshots]);

  const filterTransaksi = listTransaksi.filter(
    (doc: any) =>
      doc?.id.toLowerCase().includes(filter.toLowerCase()) ||
      doc?.data()?.detail?.nama?.toLowerCase().includes(filter.toLowerCase())
  )?.sort((a : any,b : any)=> b?.data()?.riwayat[0]?.waktu - a?.data()?.riwayat[0]?.waktu);

  return (
    <>
    <IonToolbar>
      <IonSearchbar
        value={filter}
        onIonChange={(el) => setFilter(el.detail.value!)}
        className="ion-margin-top"
        mode="ios"
        placeholder="Cari transaksi"
      />
    </IonToolbar>
    <IonItemGroup>
      {loading && (
        <>
          <IonItem button detail>
            <IonLabel>
              <IonSkeletonText style={{ width: "12em" }} />
              <p>
                <IonSkeletonText style={{ width: "8em" }} />
              </p>
            </IonLabel>
          </IonItem>
          <IonItem button detail>
            <IonLabel>
              <IonSkeletonText style={{ width: "12em" }} />
              <p>
                <IonSkeletonText style={{ width: "8em" }} />
              </p>
            </IonLabel>
          </IonItem>
          <IonItem button detail>
            <IonLabel>
              <IonSkeletonText style={{ width: "12em" }} />
              <p>
                <IonSkeletonText style={{ width: "8em" }} />
              </p>
            </IonLabel>
          </IonItem>
          <IonItem button detail>
            <IonLabel>
              <IonSkeletonText style={{ width: "12em" }} />
              <p>
                <IonSkeletonText style={{ width: "8em" }} />
              </p>
            </IonLabel>
          </IonItem>
        </>
      )}
      {snapshots && !loading && (
        <>
          {filterTransaksi?.length === 0 && (
            <IonItem>
              <IonLabel>
                <p>Tidak ada transaksi selesai</p>
              </IonLabel>
            </IonItem>
          )}

          {filterTransaksi?.map((trx: any) => {
            const data = trx.data();

            return (
              <React.Fragment key={trx.id}>
                <IonItem
                  button
                  detail
                  routerLink={"/app/transaction/view/" + data.id}
                >
                  <IonLabel>
                    Transaksi {data.id}
                    <p>
                      Dipesan oleh {data.detail.nama} pada{" "}
                      {format(data.riwayat[0].waktu.toDate(), "dd MMMM yyyy", {
                        locale: indo,
                      })}
                    </p>
                  </IonLabel>
                </IonItem>
              </React.Fragment>
            );
          })}
        </>
      )}
    </IonItemGroup>
    </>
  );
};

export default TransactionFinish;
